import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { ProductLocationsApiAdapter, ProductLocation } from '../adapters/ProductLocationsApiAdapter';

export const useProductLocations = (productId: number | undefined) => {
    const httpClient = createHttpClient(apiClientWH);
    const adapter = new ProductLocationsApiAdapter(httpClient);

    const { data: list = [], isLoading } = useQuery<ProductLocation[]>({
        queryKey: ['entry-product-locations', productId],
        queryFn: () => adapter.getProductLocations(productId != null ? [productId] : []),
        enabled: !!productId,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });

    return { locations: list, isLoading };
};
